<template>
	<el-upload
		ref="upload"
		v-model:file-list="model"
		:action="uploadURL"
		:multiple="is_multi"
		:limit="limit"
		accept="image/*"
		list-type="picture-card"
		:on-success="success"
		:on-preview="handlePictureCardPreview"
		:on-remove="handleRemove"
		:on-exceed="handleExceed"
		:before-upload="beforeUpload"
	>
		<el-icon><Plus /></el-icon>
	</el-upload>
	<!-- 图片预览 -->
	<el-image-viewer
		v-if="showImagePreview"
		:zoom-rate="1.2"
		@close="closePreview"
		:url-list="previewList"
	/>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import cfg from '@/config/config.js'
const uploadURL = cfg.HOST2 + '/XuelianAdmin/uploadOss'
const showImagePreview = ref(false)
const previewList = ref([])
const model = defineModel({ type: Array, default: [] })

const props = defineProps({
	// 是否多文件上传
	multiple: {
		type: Boolean,
		default: false
	}
})
const limit = ref(1)
const is_multi = ref(true)
const upload = ref()
const emit = defineEmits(['change'])
const stopUpload = ref(false)
onMounted(() => {})
const beforeUpload = (file) => {
	const allowedFileTypes = [
		'image/jpeg', // JPEG 图像文件
		'image/png' // PNG 图像文件
	]
	// 获取文件的类型
	const fileType = file.type
	if (!allowedFileTypes.includes(fileType)) {
		stopUpload.value = true
		ElMessage({
			type: 'error',
			message: '上传格式错误'
		})
		return false // 阻止文件上传
	}
}
const success = (e) => {
	model.value = [
		{
			url: e.data.osspath
		}
	]
}
/**
 * 移除文件，删除
 * @param file
 */
function handleRemove(file) {
	model.value = []
	previewList.value = []
}

function handleExceed(files) {
	upload.value.clearFiles()
	upload.value.handleStart(files[0])
	upload.value.submit()
}
/**
 * 预览
 * @param file
 */
function handlePictureCardPreview(file) {
	previewList.value = []
	previewList.value.push(file.url)
	showImagePreview.value = true
}
const closePreview = () => {
	showImagePreview.value = false
}
</script>

<style scoped>
:deep(.el-upload--picture-card) {
	--el-upload-picture-card-size: 100px;
	display: inline-flex !important;
}
:deep(.el-upload-list--picture-card) {
	--el-upload-list-picture-card-size: 100px;
}

:deep(.el-upload-list--picture-card .el-progress) {
	transform: translate(-50%, -50%) scale(0.8);
}
</style>
